__turbopack_context__.v({
  "button": "notForYouSection-module-scss-module__wFpIoW__button",
  "container": "notForYouSection-module-scss-module__wFpIoW__container",
  "description": "notForYouSection-module-scss-module__wFpIoW__description",
  "heading": "notForYouSection-module-scss-module__wFpIoW__heading",
  "line": "notForYouSection-module-scss-module__wFpIoW__line",
  "shareJob": "notForYouSection-module-scss-module__wFpIoW__shareJob",
});
